import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { useTheme as useMuiTheme } from '@mui/material/styles';
import { NO_SUBTAGS_EMPTY_STATE, type NoSubtagsEmptyStateCopy } from './automationTabConstants';

export interface AutomationNoSubtagsEmptyStateProps {
  onOpenChannelConfigEdit?: () => void;
  dimmed?: boolean;
  copy?: NoSubtagsEmptyStateCopy;
}

/** UI-04 — Empty state when the channel has no subtags configured */
const AutomationNoSubtagsEmptyState: React.FC<AutomationNoSubtagsEmptyStateProps> = ({
  onOpenChannelConfigEdit,
  dimmed = false,
  copy = NO_SUBTAGS_EMPTY_STATE,
}) => {
  const muiTheme = useMuiTheme();

  return (
    <Box
      sx={{
        py: 5,
        px: 3,
        textAlign: 'center',
        border: `1px dashed ${muiTheme.palette.divider}`,
        borderRadius: 1,
        opacity: dimmed ? 0.45 : 1,
      }}
    >
      <Typography variant="body1" color="text.primary" sx={{ fontWeight: 500, mb: 1.5 }}>
        {copy.heading}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {copy.instructionsPrefix}{' '}
        <Link
          component="button"
          type="button"
          variant="body2"
          onClick={onOpenChannelConfigEdit}
          disabled={!onOpenChannelConfigEdit}
          sx={{
            fontWeight: 600,
            verticalAlign: 'baseline',
            ...(onOpenChannelConfigEdit ? {} : { pointerEvents: 'none', textDecoration: 'none' }),
          }}
        >
          {copy.instructionsLink}
        </Link>{' '}
        {copy.instructionsSuffix}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {copy.footnote}
      </Typography>
    </Box>
  );
};

export default AutomationNoSubtagsEmptyState;
